import { createReducer, on } from "@ngrx/store";
import { initialState } from "./common.state";
import {
  findRoadsSuccess,
  findBoundsSuccess,
  findZonesSuccess,
  findAssetCodesSuccess,
  findAssetCodesGroupDistinctSuccess,
  findLccasSuccess,
  findLccaPeriodicalsSuccess,
  findLccaTriggersSuccess,
  findLccaTypesSuccess,
  findLccaUnitsSuccess,
} from "./common.actions";

export const commonReducer = createReducer(
  initialState,
  on(findRoadsSuccess, (state, action) => ({
    ...state,
    roadResult: action.roads,
  })),
  on(findBoundsSuccess, (state, action) => ({
    ...state,
    boundResult: action.bounds,
  })),
  on(findZonesSuccess, (state, action) => ({
    ...state,
    zoneResult: action.zones,
  })),
  on(findAssetCodesSuccess, (state, action) => ({
    ...state,
    assetCodeResult: action.assetCodes,
  })),
  on(findAssetCodesGroupDistinctSuccess, (state, action) => ({
    ...state,
    assetCodesGroupDistinctResult: action.assetCodesGroupDistinct,
  })),
  on(findLccasSuccess, (state, action) => ({
    ...state,
    lccaResult: action.lccas,
  })),
  on(findLccaPeriodicalsSuccess, (state, action) => ({
    ...state,
    lccaPeriodicalResult: action.lccaPeriodicals,
  })),
  on(findLccaTriggersSuccess, (state, action) => ({
    ...state,
    lccaTriggerResult: action.lccaTriggers,
  })),
  on(findLccaTypesSuccess, (state, action) => ({
    ...state,
    lccaTypeResult: action.lccaTypes,
  })),
  on(findLccaUnitsSuccess, (state, action) => ({
    ...state,
    lccaUnitResult: action.lccaUnits,
  })),
)
